/**
 * 封装些共用的过滤器
 */
const filter = {
	/**
	 * 将 boolean 转换成 文字是否
	 * @param value
	 * @returns {string}
	 */
	booleanToText: function(value){
		return value ? '是' : '否'
	}
}

export default filter
